/**
 * @generated SignedSource<<57c15eaa1c9a4fc7e12be3f419c9621b>>
 * @relayHash d0de07a1c5367280b784dabb3b1e46fa
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d0de07a1c5367280b784dabb3b1e46fa

import { ConcreteRequest } from 'relay-runtime';
export type Ch_deletePsychotherapyPrescriptionInput = {
  id: string;
};
export type useChDeletePsychologicalPsychoTherapyMutation$variables = {
  input: Ch_deletePsychotherapyPrescriptionInput;
};
export type useChDeletePsychologicalPsychoTherapyMutation$data = {
  readonly ch_deletePsychotherapyPrescription: {
    readonly ch_PsychotherapyPrescription: {
      readonly id: string;
    } | null;
  };
};
export type useChDeletePsychologicalPsychoTherapyMutation = {
  response: useChDeletePsychologicalPsychoTherapyMutation$data;
  variables: useChDeletePsychologicalPsychoTherapyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChDeletePsychologicalPsychoTherapyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deletePsychotherapyPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_deletePsychotherapyPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_PsychotherapyPrescription",
            "kind": "LinkedField",
            "name": "ch_PsychotherapyPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChDeletePsychologicalPsychoTherapyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deletePsychotherapyPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_deletePsychotherapyPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_PsychotherapyPrescription",
            "kind": "LinkedField",
            "name": "ch_PsychotherapyPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "d0de07a1c5367280b784dabb3b1e46fa",
    "metadata": {},
    "name": "useChDeletePsychologicalPsychoTherapyMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "36d3375eda82ee5fbd0be6c6d5b9f2e9";

export default node;
